<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="has_perm('view_apartment_realestate') || GET_ACCOUNT_DATA.id == 1"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartment_realestate.title") }}</b>
              <lte-button
                v-if="
                  GET_ACCOUNT_DATA.id == 1 ||
                    has_perm('create_apartment_realestate')
                "
                style="float:right;"
                type="btn
                btn-primary"
                right_icon="fa
                fa-plus"
                @click="addNew($event)"
                >{{ $t("common.add") }}</lte-button
              >
              <lte-button
                v-if="
                  GET_ACCOUNT_DATA.id == 1 ||
                    has_perm('delete_apartment_realestate')
                "
                style="float:right;"
                type="btn btn-danger"
                right_icon="glyphicon glyphicon-remove"
                @click="onDeleteBDS()"
                >{{ $t("apartment_realestate.delete.button") }}</lte-button
              >
            </div>
            <select-option-check
              style="margin-top:-40px;"
              :item="columnsApartment"
              class="dropdown-trigger"
              data-icon="eye"
              @callbackData="onColumnSelect"
            ></select-option-check>
          </div>
          <div class="box-body">
            <lte-table
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridApartmentDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :useFilter="useFilter"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('update_apartment_realestate') &&
                  has_perm('delete_apartment_realestate'))
                  ? actions
                  : has_perm('update_apartment_realestate')
                  ? [actions[0]]
                  : has_perm('delete_apartment_realestate')
                  ? [actions[1]]
                  : []
              "
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :isGetInformationInvoice="true"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
            ></lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
    <div class="modal fade" :ref="`modal-delete`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartment_realestate.delete.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-6 col-sm-6">
                <span>{{
                  $t("apartment_realestate.delete.comment_head")
                }}</span>
                <span>{{ list_apartment_id.length }}</span>
                <span>{{
                  $t("apartment_realestate.delete.comment_tail")
                }}</span>
              </div>
              <div class="col-md-64 col-sm-6">
                <label class="col-md-12 col-sm-12">{{
                  $t("apartment_realestate.code")
                }}</label>
                <span
                  v-for="item in list_apartment_code"
                  v-bind:key="item"
                  class="col-md-12 col-sm-12"
                  >{{ item }}</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closeModalDelete()"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              v-if="GET_ACCOUNT_DATA.id == 1"
              @click="deleteBDS()"
              class="btn btn-primary"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";

export default {
  name: "ApartmentRealestateList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      useFilter: false,
      boxStyle: false,
      useCheckBox: true,
      list_apartment_id: [],
      list_apartment_code: [],
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "apartment_realestate.code", isHidden: true },
        { text: "apartment_realestate.type", isHidden: true },
        { text: "apartment_realestate.size", isHidden: true },
        { text: "apartment_realestate.project", isHidden: true },
        { text: "apartment_realestate.block", isHidden: true },
        { text: "apartment_realestate.floor", isHidden: true },
        { text: "apartment_realestate.room_number", isHidden: true },
        { text: "apartment_realestate.note", isHidden: true }
      ],
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      statusSelected: [],
      actions: ["common.modify", "common.delete"],
      // actions: ["common.modify", "common.add_retail_service"],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalMoveToServiceApartment: false,
      paginatorItem: {
        commit_function: "GET_APARTMENT_REALESTATE_LIST"
      },
      // search: {
      //   code: "",
      //   apartment_code: "",
      //   fromsize: "",
      //   tosize: "",
      //   status: "",
      //   owner_resident: ""
      // },
      isLoading: false
    };
  },
  watch: {
    GET_LANG: function() {
      this.columnApartmentStatus.data_list = [];
      const data = {
        params: {
          page: 1
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_REALESTATE_LIST(data);
    },

    GET_APARTMENT_REALESTATE_DATA: function() {
      this.gridApartmentDataList = [];
      this.GET_APARTMENT_REALESTATE_DATA.forEach((apartment, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = apartment.realestate_code;
        let id = apartment.id;
        let size = apartment.size;

        let type = utils.getRealestateTypeName(apartment.realestate_type);
        let project = apartment.project_detail.project_name;

        let bedroom_count = apartment.bedroom_count;
        let block = apartment.block;
        let floor = apartment.floor;
        let note = apartment.other_details;

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "apartment_realestate.code": code,
          "apartment_realestate.type": type,
          "apartment_realestate.size": size,
          "apartment_realestate.project": project,
          "apartment_realestate.block": block,
          "apartment_realestate.floor": floor,
          "apartment_realestate.room_number": bedroom_count,
          "apartment_realestate.note": note
        };
        this.gridApartmentDataList.push(data);
      });
      this.isLoading = false;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        let newGridColumns = [];
        if (this.gridColumns.length == viewedColumns.length) {
          for (
            let j = 0, sizeOrigin = this.gridColumns.length;
            j < sizeOrigin;
            j++
          ) {
            for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
              if (this.gridColumns[j].text == viewedColumnsKey[i]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = viewedColumnsKey[i];
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                newGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = newGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
        // update when add columns in table
        else if (this.gridColumns.length != viewedColumnsKey.length) {
          let updateGridColumns = [];
          for (let i = 0; i < this.gridColumns.length; i++) {
            for (let j = 0; j < viewedColumnsKey.length; j++) {
              if (this.gridColumns[i] != viewedColumnsKey[j]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = this.gridColumns[i].text;
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                updateGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = updateGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_APARTMENT_REALESTATE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },

    // Chọn cột
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentrealestatelist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentRealestateAdd",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("update_apartment_realestate")
        ) {
          this.$router.push({
            name: "ApartmentRealestateAdd",
            params: {
              id: recordData.id
            }
          });
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t("apartment_realestate.delete.not_permission"),
            styleType: "danger"
          });
        }
      } else {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("delete_apartment_realestate")
        ) {
          this.$refs.lte_table.removeSelected();
          this.resetData();
          this.list_apartment_id.push(recordData.id);
          this.list_apartment_code.push(
            recordData["apartment_realestate.code"]
          );
          this.onDeleteBDS();
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t("apartment_realestate.delete.not_permission"),
            styleType: "danger"
          });
        }
        //   });
        // } else {
        //   // check has_perm trước khi chạy vào hàm xóa, waitting for issue 1652
        //   this.$refs.lte_table.removeSelected()
        //   this.resetData()
        //   this.list_apartment_id.push(recordData.id)
        //   this.list_apartment_code.push(recordData["apartment_realestate.code"])
        //   this.onDeleteBDS()
      }
    },
    resetData() {
      this.list_apartment_id = [];
      this.list_apartment_code = [];
    },
    onPagination: function(data) {
      this.isLoading = true;
      this.GET_APARTMENT_REALESTATE_LIST(data);
    },
    selectedItems: function(dataSelected) {
      this.resetData();
      for (let i = 0, size = dataSelected.length; i < size; i++) {
        this.list_apartment_id.push(dataSelected[i].id);
        this.list_apartment_code.push(
          dataSelected[i]["apartment_realestate.code"]
        );
      }
    },
    onDeleteBDS: function() {
      if (this.list_apartment_id.length == 0) {
        this.ON_SHOW_TOAST({
          message: this.$t("apartment_realestate.delete.error"),
          styleType: "danger"
        });
      } else {
        $(this.$refs[`modal-delete`]).modal("show");
      }
    },
    async deleteBDS() {
      let data = {
        data: this.list_apartment_id
      };
      await this.DELETE_APARTMENT_REALESTATE_LIST(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.resetData();
            this.onSearch(1);
            $(this.$refs[`modal-delete`]).modal("hide");
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },

    onSearch(page) {
      // Remove selected item in table before search
      this.$refs.lte_table.removeSelected();

      const data = {
        params: {
          page: page
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_REALESTATE_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
      const filter = {
        params: {
          tablename: "apartmentrealestatelist"
        }
      };
      this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    },

    closeModalDelete: function() {
      $(this.$refs[`modal-delete`]).modal("hide");
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_REALESTATE_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "ON_SHOW_TOAST",
      "DELETE_APARTMENT_REALESTATE_LIST"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    // this.isLoading = true;
    this.GET_APARTMENT_REALESTATE_LIST(data);
    this.columnsApartment.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentrealestatelist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentRealestateList.vue